import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="image, heading, text1" mdxType="Hero" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cpp/static/9a260218c4297a6938367b68ce240a55/5530d/header_gradient.webp 320w", "/cpp/static/9a260218c4297a6938367b68ce240a55/0c8fb/header_gradient.webp 640w", "/cpp/static/9a260218c4297a6938367b68ce240a55/94b1e/header_gradient.webp 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cpp/static/9a260218c4297a6938367b68ce240a55/8980b/header_gradient.jpg 320w", "/cpp/static/9a260218c4297a6938367b68ce240a55/56d4e/header_gradient.jpg 640w", "/cpp/static/9a260218c4297a6938367b68ce240a55/62aaf/header_gradient.jpg 1280w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/cpp/static/9a260218c4297a6938367b68ce240a55/62aaf/header_gradient.jpg",
            "alt": "Hero image",
            "title": "Hero image",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h1 {...{
      "id": "training"
    }}>{`Training`}</h1>
    <p>{`A collection of expert-led training videos on C++ development, produced by Adobe's top engineers`}</p>
    <h2 {...{
      "id": "adobe-software-technology-labs-better-code-seminar"
    }}>{`Adobe Software Technology Lab's Better Code Seminar`}</h2>
    <p>{`The Better Code Seminar is an interactive and informative event designed to
enhance your programming skills and elevate the quality of your code. Our goal
is to provide you with a comprehensive understanding of the principles that
underlie great code, based on the latest research and deep thinking in the
field.`}</p>
    <h3 {...{
      "id": "better-code-contracts"
    }}>{`Better Code: Contracts`}</h3>
    <p>{`Does it sometimes feel like all computer systems are held together with duct
tape and good intentions? Do you have confidence that the code you write, and
the changes you make, are correct? What does “correct” even mean? How do we know
the code we write today won’t become a long-term liability? These persistent
questions can be enough to suck all the fun out of programming, but it doesn’t
have to be that way. In this talk, we’ll look at the connective tissue of good
code, and show how to keep it strong and supple. We’ll suggest replacing code
reviews with something better and chart the path to a more hopeful future of
software.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Dave Abrahams`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/7WktGyfXhwM"
      }}><strong parentName="a">{`See the recording...`}</strong></a></p>
    <h3 {...{
      "id": "better-code-algorithms---preliminaries"
    }}>{`Better Code: Algorithms - Preliminaries`}</h3>
    <p>{`A function is a fundamental building block in software development and a key
tool for designing efficient and maintainable systems. This talk looks at the
characteristics of a “good” function and provides practical guidance on when and
how to refactor and utilize existing libraries to develop Better Code.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Sean Parent`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/wtOkvB_iFw4"
      }}><strong parentName="a">{`See the recording...`}</strong></a></p>
    <h3 {...{
      "id": "better-code-functional-design"
    }}>{`Better Code: Functional Design`}</h3>
    <p>{`Functional languages emphasize powerful, simple, and composable APIs, but you
don't need to use these languages to benefit from their advantages.`}</p>
    <p>{`This talk introduces functional design and showcases its application to several
real-world problems. It covers denotational semantics and several math-based
programming abstractions. Finally, functional solutions are compared with
traditional ones.`}</p>
    <p>{`No prior knowledge of functional programming is required for this talk.`}<br parentName="p"></br>{`
`}<em parentName="p">{`David Sankel`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/Ijpe9oaF26k"
      }}><strong parentName="a">{`See the recording...`}</strong></a></p>
    <h3 {...{
      "id": "better-code-reliable-types"
    }}>{`Better Code: Reliable Types`}</h3>
    <p>{`Types are as fundamental as algorithms when architecting any software system. By
designing our types around relationships already in our code, and rigorously
upholding those relationships with our type invariants, we can build more
reliable systems that are easier to reason about. We cover type design and
making invalid states unrepresentable with algebraic data types.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Nick DeMarco`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/J7Aql-rdx6Y"
      }}><strong parentName="a">{`See the recording...`}</strong></a></p>
    <h3 {...{
      "id": "better-code-algorithms---composition"
    }}>{`Better Code: Algorithms - Composition`}</h3>
    <p>{`Algorithm composition is the process of combining existing algorithms to create
new ones that solve complex problems. This talk looks at different forms of
composition with different trade-offs. The talk will inspire you to think of
algorithms as reusable building blocks that can be combined in novel ways.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Sean Parent`}</em></p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/HJb6Czi0Ky0"
      }}><strong parentName="a">{`See the recording...`}</strong></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      